import {getChunkLoadDiagnostics, isChunkLoadError} from './chunkLoadRecovery';

const INSTAGRAM_IAB_ERROR = "undefined is not an object (evaluating 'window._META.IABInnerFrame')";

const isInstagramIabError = event => {
  if (!/\bInstagram(?:\s|\/)/i.test(navigator.userAgent)) return false;
  if (!event.unhandled || event.errors?.length !== 1) return false;

  const [error] = event.errors;
  if (error.errorClass !== 'TypeError' || error.errorMessage !== INSTAGRAM_IAB_ERROR) {
    return false;
  }

  // CB-3164: Instagram's injected script reports only the HTML page at line 1.
  // Keep reports with application frames or insufficient evidence.
  return (
    error.stacktrace?.length > 0 &&
    error.stacktrace.every(frame => {
      if (frame.inProject || frame.lineNumber !== 1) return false;
      if (frame.method && frame.method !== 'global code') return false;

      try {
        const source = new URL(frame.file);
        return (
          source.origin === window.location.origin && source.pathname === window.location.pathname
        );
      } catch {
        return false;
      }
    })
  );
};

export const addChunkLoadDiagnostics = (event, error) => {
  if (!isChunkLoadError(error)) return;

  event.addMetadata('chunkLoad', getChunkLoadDiagnostics(error));
  event.context = 'chunk-load-error';
};

export const handleBugsnagError = event => {
  if (isInstagramIabError(event)) return false;

  addChunkLoadDiagnostics(event, event.originalError);
};
